import { Action } from "@ngrx/store";

import { Credential } from "../../models";

export enum AuthActionTypes {
  Login = "[Auth] Page Login",
  LoginFailure = "[Auth] Api Login Failure",
  LoginSuccess = "[Auth] Api Login Success",
  LoginJustLogged = "[Auth] Guard Login Just Logged",
  LoginReset = "[Auth] Guard Login Reset",
  Logout = "[Auth] Page Logout",
  ReloadToken = "[Auth] Reload Token"
  // LogoutFailure = "[Auth] Api Logout Failure",
  // LogoutSuccess = "[Auth] Api Logout Success"
}

export class Login implements Action {
  readonly type = AuthActionTypes.Login;

  constructor() { }
}

export class LoginFailure implements Action {
  readonly type = AuthActionTypes.LoginFailure;

  constructor(readonly payload: { error: any }) {}
}

export class LoginSuccess implements Action {
  readonly type = AuthActionTypes.LoginSuccess;

  constructor(readonly payload: { token: string, jwt: string, username: string }) { }
}

export class LoginJustLogged implements Action {
  readonly type = AuthActionTypes.LoginJustLogged;
}

export class LoginReset implements Action {
  readonly type = AuthActionTypes.LoginReset;
}

export class Logout implements Action {
  readonly type = AuthActionTypes.Logout;

  constructor(readonly payload?: { returnUrl: string }) {}
}

export class ReloadToken implements Action {
  readonly type = AuthActionTypes.ReloadToken;
}

export type AuthActions =
  | Login
  | LoginFailure
  | LoginJustLogged
  | LoginReset
  | LoginSuccess
  | Logout
  | ReloadToken;
